import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { money } from '../utils/money';

const API_BASE = '/api';
const rm = (n) => money(Number(n) || 0);

export default function BankAccountsSettings() {
  const { token } = useAuth();
  const [rows, setRows] = useState([]);
  const [msg, setMsg] = useState(null);
  const headers = useCallback(() => ({ Authorization: `Bearer ${token}` }), [token]);

  const load = useCallback(async () => {
    const res = await axios.get(`${API_BASE}/bank-balances/all`, { headers: headers() });
    setRows(res.data.accounts.map((a, i) => ({ ...a, sort_order: a.sort_order || i })));
  }, [headers]);

  useEffect(() => { load(); }, [load]);

  // Key on company+code: the same code exists in multiple companies.
  const keyOf = (r) => `${r.company}|${r.bukku_code}`;
  const toggle = (k) => setRows(rows.map(r => keyOf(r) === k ? { ...r, is_displayed: !r.is_displayed } : r));
  const setOrder = (k, v) => setRows(rows.map(r => keyOf(r) === k ? { ...r, sort_order: parseInt(v, 10) || 0 } : r));

  const save = async () => {
    setMsg(null);
    try {
      await axios.put(`${API_BASE}/bank-balances/display`,
        rows.map(r => ({ company: r.company, bukku_code: r.bukku_code, is_displayed: r.is_displayed, sort_order: r.sort_order })),
        { headers: headers() });
      setMsg('Saved');
      setTimeout(() => setMsg(null), 3000);
    } catch (e) {
      setMsg(e.response?.data?.error || 'Save failed');
    }
  };

  return (
    <div className="page">
      <h1>Bank Accounts</h1>
      <p className="muted">Tick the accounts to show on the Dashboard. Order controls display order. Balances sync from Bukku daily.</p>
      {msg && <div className="alert alert-success">{msg}</div>}
      <table className="data-table">
        <thead><tr><th>Show</th><th>Order</th><th>Company</th><th>Account</th><th>Code</th><th>Balance</th></tr></thead>
        <tbody>
          {rows.map(r => (
            <tr key={keyOf(r)}>
              <td><input type="checkbox" checked={!!r.is_displayed} onChange={() => toggle(keyOf(r))} /></td>
              <td><input type="number" style={{ width: 60 }} value={r.sort_order} onChange={e => setOrder(keyOf(r), e.target.value)} /></td>
              <td>{r.company}</td>
              <td>{r.name}</td>
              <td>{r.bukku_code}</td>
              <td>{rm(r.balance)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <button className="btn-primary" onClick={save} style={{ marginTop: 16 }}>Save</button>
    </div>
  );
}
